import { StatusType } from '../../types/user'
import { useDispatch } from 'react-redux'
import { useStaffMeta } from '../../hooks/useStaffMeta'
import Loading from '../ui/Loading'
import { clearTypeOfOpen, updateCreateNewStaffField } from '../../features/user/userSlice'

interface StatusListProps {
    statusList: StatusType[]
}

export default function StatusList({ statusList }: StatusListProps) {
    
    const dispatch = useDispatch()
    const { isLoadingStatus, isErrorStatus } = useStaffMeta()
    
    return (
        <ul className="absolute w-full overflow-hidden mt-1 bg-white border rounded shadow-lg z-10 border-gray-400">
            {isLoadingStatus ? (
                <li className='px-3 py-1.5 md:px-5 md:py-2 hover:bg-gray-100 cursor-pointer text-[12px] md:text-[13px] w-full'>
                    <Loading isDefault={false}/>
                </li>
            ) : isErrorStatus ? (
                <li className="px-3 py-1.5 md:px-5 md:py-2 hover:bg-gray-100 cursor-pointer text-[12px] md:text-[13px] w-full">
                    Failed to load status.
                </li>
            ): (
                statusList.map((opt, i) => (
                    <li
                        key={i}
                        onClick={() => {
                            dispatch(updateCreateNewStaffField({ field: 'status', value: opt }))
                            dispatch(clearTypeOfOpen())
                        }}
                        className='px-3 py-1.5 md:px-5 md:py-2 hover:bg-gray-100 cursor-pointer text-[12px] md:text-[13px] w-full'
                    >
                        {opt.status}
                    </li>
                ))
            )}
        </ul>
    )
}
